export const DEFAULT_POINT_COUNT = 2000;
export const DEFAULT_FILTERED_POINT_COUNT = 5000;
export const DEFAULT_PAGINATED_PAGE_SIZE = 500;
